function updateClasses({ $el, slides, activeIndex }) {
    $el.find('.b-publications__container .swiper-slide-prev-prev').removeClass('swiper-slide-prev-prev');
    slides.eq(activeIndex).prev().prev().addClass('swiper-slide-prev-prev');

    $el.find('.b-publications__container .swiper-slide-next-next').removeClass('swiper-slide-next-next');
    slides.eq(activeIndex).next().next().addClass('swiper-slide-next-next');
}
document.addEventListener('DOMContentLoaded', () => {

    const getSort = ({ target }) => {
        const order = (target.dataset.order = -(target.dataset.order || -1));
        const index = [...target.parentNode.cells].indexOf(target);
        const collator = new Intl.Collator(['en', 'ru'], { numeric: true });
        const comparator = (index, order) => (a, b) => order * collator.compare(
            a.children[index].innerHTML,
            b.children[index].innerHTML
        );

        for(const tBody of target.closest('table').tBodies)
            tBody.append(...[...tBody.rows].sort(comparator(index, order)));

        for(const cell of target.parentNode.cells)
            cell.classList.toggle('sorted', cell === target);
    };

    document.querySelectorAll('.table_sort thead').forEach(tableTH => tableTH.addEventListener('click', () => getSort(event)));

});

$(document).ready(function () {

    // === Begin button ripple style === \\\
    $(".ripple").on("click", function(event) {
        var _this = $(this),
            offset = $(this).offset(),
            positionX = (event.pageX - offset.left),
            positionY = (event.pageY - offset.top);
        _this.append("<span class='ripple-effect'>");
        _this.find(".ripple-effect").css({
            left: positionX,
            top: positionY
        }).animate({
            opacity: 0,
        }, 1500, function() {
            $(this).remove();
        });
    });
// === End button ripple style === \\\


    $('.menu-icon').click(function(){
        $('.b-nav').toggleClass('active');
        $('body').toggleClass('body-overflow');
        $('.menu-icon').toggleClass('active');
        $(document).on('click', function(event) {
            if (!$(event.target).closest(".b-nav , .menu-icon").length) {
                $('.b-nav').removeClass('active');
                $('body').removeClass('body-overflow');
                $('.menu-icon').removeClass('active');
            }
            event.stopPropagation();
        });
    });

    function moveMenu(){
        if ($(window).width() < 992) {
            $(function(){

                $(".b-drop > a").click(function(event){
                    $(this).parent().toggleClass('active');
                    $(this).next().toggleClass('active');
                    $(this).toggleClass('active');
                    event.preventDefault();
                });

                $(".sub > a").click(function(event){
                    $(this).next().toggleClass('active');
                    $(this).toggleClass('active');
                    event.preventDefault();
                });


            })
        } else{
            $(function(){


            })
        }
    }
    moveMenu();

    $(window).resize(function(){
        moveMenu();
    });


    var swiper = new Swiper(".b-slider", {
        slidesPerView: 1,
        effect: "fade",
        navigation: {
            nextEl: '.b-slider .swiper-button-next',
            prevEl: '.b-slider .swiper-button-prev',
        }
    });


    var swiper = new Swiper(".b-module__swiper", {
        slidesPerView: 1,
        loop: false,
        navigation: {
            nextEl: '.b-module__swiper .swiper-button-next',
            prevEl: '.b-module__swiper .swiper-button-prev',
        },
        pagination: {
            el: ".b-module .swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 1
            },
            768: {
                slidesPerView: 3
            },
            1024: {
                slidesPerView: 3
            },
        },
    });

    var swiper = new Swiper(".b-partners", {
        slidesPerView: 2,
        freeMode: true,
        loop: true,
        speed: 5000,
        autoplay: {
            enabled: true,
            delay: 1,
        },
        breakpoints: {
            640: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 4
            },
            1024: {
                slidesPerView: 5
            },
        },
    });



    var scrolledpx = parseInt($(window).scrollTop());
    $(window).scroll( function (){

        scrolledpx = parseInt($(window).scrollTop());

        if(scrolledpx > 112){
            $('.b-header').addClass('header-fix');
        } else if(scrolledpx < 113){
            $('.b-header').removeClass('header-fix');
        }
    })


    $('.b-table_open .btn-plus').click(function(){
        $(this).parent().parent().next().toggleClass('active');
        $(this).toggleClass('active');
    });


    $('.search-btn').click(function(event){
        $('.search-modal').toggleClass('active');
        $(this).toggleClass('active');
        $('body').toggleClass('active');
        event.preventDefault();
    });
    $('.search-modal__close').click(function(){
        $('.search-modal').removeClass('active');
        $('body').removeClass('active');
    });


});


var mySwiper = new Swiper(".publications-slider", {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: false,
    initialSlide: "1",
    speed: 600,
    observer: true,
    observeParents: true,
    on: {
        init() {
            updateClasses(this);
        },
        slideChange() {
            updateClasses(this);
        },
    },
    slideToClickedSlide: true,
    spaceBetween: 0,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: '.publications-slider .swiper-button-next',
        prevEl: '.publications-slider .swiper-button-prev',
    },
});

$(window).resize(function(){
    mySwiper.update()
})


mySwiper.slideNext(0);

